import React from 'react';

import Routes from './page';

export function CertsRoutes() {
  return (
    <React.StrictMode>
      <Routes />
    </React.StrictMode>
  );
}

export { default as certsReducer } from './redux';
